module.exports = __webpack_public_path__ + "static/media/cars_Drive.bf4e9094.png";